export default __webpack_public_path__ + "static/media/shopping.08523305.svg";